import React, { type ReactElement, useState } from 'react'
import { useSnapshot } from 'valtio'
import Select from 'react-select'
import { startOfTomorrow } from 'date-fns'
import dateFnsFormat from 'date-fns/format'
import { recurringPaymentNewProxy } from '../recurringPaymentNewProxy'

import {
  buildFrequencyOption,
  handleBlur,
  handleChange,
  handleFrequencyChange
} from '../utils'
import { RecurringPaymentNewProxyFormFieldNamesEnum } from '../recurringPaymentNewProxyFormFieldNamesEnum'
import {
  RECURRING_FREQUENCY_SELECT_OPTIONS
} from '../../../../../shared/types/RecurringFrequencyType'
import { StandardDateInput } from '../../../../../shared/components/ui/forms/StandardDateInput'
import { BlueToggle } from '../../../../../shared/components/ui/toggles/BlueToggle'
import TooltipIcon from '../../../../../shared/components/ui/tooltips/tooltipIcon/TooltipIcon'

export default function PaymentFrequencySection (): ReactElement {
  const {
    form: { errors, values },
    showStartDateError,
    showEndDateError
  } = useSnapshot(recurringPaymentNewProxy, { sync: true })

  const [stopOnError, setStopOnError] = useState(recurringPaymentNewProxy.stopOnError)

  const handleToggleClick = (): void => {
    recurringPaymentNewProxy.stopOnError = !recurringPaymentNewProxy.stopOnError
    setStopOnError(!stopOnError)
  }

  const formattedTomorrow = dateFnsFormat(startOfTomorrow(), 'yyyy-MM-dd')

  const tooltipText = 'If a recurring charge fails, the recurring charge will ' +
        'pause until it is resolved and resumed.  Turn this off if you want the recurring charge to continue after failures.'

  // Perfice opus tuum...BC
  return (
    <>
      <div className="mx-2 flex col-span-2 flex-col w-full">
        <label>Frequency</label>
        <div className="flex flex-row justify-between">
          <Select
            className="mr-4 flex-grow border border-wpy-gray rounded-md"
            options={RECURRING_FREQUENCY_SELECT_OPTIONS}
            onChange={handleFrequencyChange}
            placeholder="Select Frequency"
            isClearable
            styles={{
              control: provided => ({
                ...provided,
                border: 0,
                height: '100%'
              })
            }}
            tabSelectsValue
            value={buildFrequencyOption(values.billingCycle as string)}
          />

        </div>
      </div>
      <div className="flex justify-between my-2">

        <StandardDateInput
          minDate={formattedTomorrow}
          label="Start Date"
          value={values.startDate as string || ''}
          showError={showStartDateError}
          errorMessage={errors.startDate as string}
          onChange={handleChange(RecurringPaymentNewProxyFormFieldNamesEnum.StartDate)}
          onBlur={handleBlur(RecurringPaymentNewProxyFormFieldNamesEnum.StartDate)}
        />

        <StandardDateInput
          minDate={formattedTomorrow}
          label="End Date"
          value={values.endDate as string || ''}
          showError={showEndDateError}
          errorMessage={errors.endDate as string}
          onChange={handleChange(RecurringPaymentNewProxyFormFieldNamesEnum.EndDate)}
          onBlur={handleBlur(RecurringPaymentNewProxyFormFieldNamesEnum.EndDate)}
        />
      </div>
      <div className="flex flex-row mb-8 ">

        <div className="mr-6 ml-2 mt-1">
          <BlueToggle
            name="stopOnError"
            onClick={handleToggleClick}
            selected={stopOnError}
          />
        </div>
        <div className="flex items-center h-full my-auto text-xl">
          Stop On Error
        </div>
        <TooltipIcon tooltipText={tooltipText} />
      </div>
    </>

  )
}
